(ns minorodata.components.file-ingest.modal
  (:require [minorodata.components.spinner.core :as c.spinner]
            [ui.button :refer [button]]
            [ui.dialog :refer [dialog-actions dialog-content
                               dialog-description dialog-root dialog-title]]))


(defn error-modal [{:keys [error reset-error-callback]}]
  [dialog-root {:open           (some? error)
                :on-open-change #(when-not % reset-error-callback)}

   [dialog-content
    [dialog-title
     (or (:ingest-error/title error)
         "Error reading your file")]

    [dialog-description
     (when (:ingest-error/show-loader? error)
       [c.spinner/spinner-lucide {:class "mr-1 align-middle"}])

     (:ingest-error/msg error)]

    [dialog-actions
     [button {:disabled (:ingest-error/show-loader? error)
              :on-click reset-error-callback}
      "Close"]]]])
